import {
  Box,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  ListSubheader,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as FinderIcon } from '../../assets/img/icon/Finder.svg';
import { ReactComponent as RightIcon } from '../../assets/img/icon/Right.svg';

const ORDERED_BY = 'license_plate';

interface VehicleListProps {
  handleFilter?: (q: string) => void;
  baseUrl?: any;
  setFunction?: (id: any) => void;
  verified?: boolean;
  selfInspections?: any;
}

const InspectionListItem: React.FC<VehicleListProps> = (props) => {
  const { setFunction, baseUrl, children } = props;

  return setFunction ? (
    <ListItem button divider onClick={setFunction}>
      {children}
    </ListItem>
  ) : (
    <ListItem divider component={Link} to={baseUrl}>
      {children}
    </ListItem>
  );
};

const SelfInspectionList: React.FC<VehicleListProps> = (props) => {
  const { setFunction, baseUrl, selfInspections, handleFilter } = props;
  const [ , setInspections] = useState<any>([]);

  useEffect(() => {
    setInspections(selfInspections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (event: any) => {
    handleFilter(event.target.value)
  };

  const classifyingVehicles = useCallback(() => {
    const firstChar = selfInspections
      .map((vehicle: any) => {
        return vehicle.vehicle[ORDERED_BY][0]
      })
      .sort(),
      filteredChar = [...new Set<string>(firstChar)];

    const FilteredCharUnique = filteredChar.filter(function (item, pos) {
      return filteredChar.indexOf(item) === pos;
    })

    return FilteredCharUnique.map((filt: string) =>
      selfInspections.filter((vehicle: any) => vehicle.vehicle[ORDERED_BY][0] === filt)
    );
  }, [selfInspections]);

  return (
    <Grid container alignItems="center">
      <Grid item xs={11} md={8} lg={7} xl={6}>
        <Grid container>
          <Grid item xs={12}>
            <Box my={3}>
              <TextField
                onInput={handleChange}
                name="search"
                fullWidth={true}
                id="search"
                placeholder="Buscá por N° de patente, Marca o Modelo "
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <FinderIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            {classifyingVehicles().map((inspection: any, index: number) => {
              return (
                <List
                  key={index}
                  subheader={
                    <ListSubheader>
                      {inspection[0].vehicle[ORDERED_BY][0]}
                    </ListSubheader>
                  }
                >
                  {inspection.map((inspectionVehicle: any) => (
                    <InspectionListItem
                      baseUrl={baseUrl + inspectionVehicle.vehicle.id}
                      setFunction={
                        setFunction ? () => setFunction(inspectionVehicle) : undefined
                      }
                    >
                      <ListItemText
                        primary={
                          <>
                            <Typography
                              component="span"
                              variant="subtitle1"
                              color="textPrimary"
                            >
                              {inspectionVehicle.vehicle[ORDERED_BY]}
                            </Typography>
                            <Typography
                              component="span"
                              variant="caption"
                              color="textPrimary"
                            >
                              {' / ' +
                                inspectionVehicle.vehicle.brand +
                                ' ' +
                                inspectionVehicle.vehicle.model}
                            </Typography>
                          </>
                        }
                      />
                      <ListItemSecondaryAction>
                        <RightIcon></RightIcon>
                      </ListItemSecondaryAction>
                    </InspectionListItem>
                  )
                  )}
                </List>
              )
            })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SelfInspectionList;
